import styled from 'styled-components';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledRowDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.color['light-gray-3']};
  margin-right: ${toRem(24)};
  margin-left: ${toRem(16)};
  @media ${theme.mediaQuery.tablet} {
    margin-left: ${toRem(0)};
    margin-right: ${toRem(0)};
  }
  .row-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    span:nth-child(2) {
      color: ${theme.color['dark-gray-3']};
      font-size: ${toRem(12)};
      letter-spacing: 0;
      line-height: ${toRem(18)};
      font-family: 'Swiss721-BT-Regular';
    }
  }
`;
